import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function LightBulb({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12.0001 6.66665C9.23866 6.66665 7.00008 8.90522 7.00008 11.6666C7.00008 13.3282 7.80992 14.8006 9.05932 15.7109L9.33342 15.9106V16.6666H14.6667V15.9106L14.9408 15.7109C16.1903 14.8006 17.0001 13.3282 17.0001 11.6666C17.0001 8.90522 14.7615 6.66665 12.0001 6.66665ZM5.66675 11.6666C5.66675 8.16884 8.50228 5.33331 12.0001 5.33331C15.4979 5.33331 18.3334 8.16884 18.3334 11.6666C18.3334 13.648 17.423 15.4167 16.0001 16.5772V18H8.00008V16.5772C6.57718 15.4167 5.66675 13.648 5.66675 11.6666Z"
        fill={iconColor}
      />
      <Path d="M22.3334 12.3333H19.6667V11H22.3334V12.3333Z" fill={iconColor} />
      <Path
        d="M19.7783 4.83128L17.8926 6.7169L16.9498 5.77409L18.8354 3.88847L19.7783 4.83128Z"
        fill={iconColor}
      />
      <Path
        d="M12.6667 1.33331V3.99998H11.3334V1.33331H12.6667Z"
        fill={iconColor}
      />
      <Path
        d="M5.16472 3.88847L7.05034 5.77409L6.10753 6.7169L4.22191 4.83128L5.16472 3.88847Z"
        fill={iconColor}
      />
      <Path
        d="M1.66675 11H4.33341V12.3333H1.66675L1.66675 11Z"
        fill={iconColor}
      />
      <Path d="M8.66675 19H15.3334V20.3333H8.66675V19Z" fill={iconColor} />
      <Path
        d="M10.0001 21.3333H14.0001V22.6666H10.0001V21.3333Z"
        fill={iconColor}
      />
    </Svg>
  );
}
